import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { Drawer } from 'antd';
import moment from 'moment';
import ReactTimeAgo from 'react-time-ago';
import UnifiedTrackingTimeline from './UnifiedShipmentView/TrackingTImeline';
import { StylesProps } from 'src/Library/Types';
import { tokens } from 'src/design-system';
import { commonStyles } from 'src/Library/CommonStyles';

const styles = theme => ({
  ...commonStyles(theme),
  drawer: {
    '& .ant-drawer-body': {
      padding: 0,
    },
  },
  parentContainer: {
    '& p': {
      marginBottom: tokens.spacing.sm,
    },
  },
  reportAnchor: {
    fontSize: tokens.fontSize.small,
    color: theme.primaryColor,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:active': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:visited': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  anchors: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100%',
    justifyContent: 'flex-start',
    marginTop: '30px',
    backgroundColor: tokens.colors.bgSubtle,
    padding: '6px 20px',
  },
  blNumber: {
    display: 'flex',
    color: tokens.colors.textTertiary,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '17px',
    marginTop: tokens.spacing.xs,
  },
  updatedAt: {
    background: tokens.colors.textTertiary,
    width: 1,
    marginLeft: tokens.spacing.sm,
  },
  title: {
    ...commonStyles(theme).flexRow,
    justifyContent: 'space-between',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  tracking: string;
  showProduct?: boolean;
  shipmentNumber?: string;
  onClose: () => void;
  reportIssue?: () => void;
  isBL: boolean;
  isBK: boolean;
  isHBL: boolean;
  visible: boolean;
  lastSuccessfulTrackingStatusUpdatedAt?: moment.MomentInput;
  blNumber: string;
  hblNumber: string;
  bookingNumber: string;
  handleOpenTracking: () => void;
  containerNumber: string;
  currentEventIndex: number;
  handleOpenProduct: () => void;
}

/**
 * NOTE: Don't forget to set locale before using it,
 * otherwise ReactTimeAgo crashes.
 * Look for 1bd3e16c35b846f9bce245756d0a6cac in the readme for more info.
 */
const SideDrawerTracking = (props: IProps) => {

  const {
    tracking,
    showProduct,
    shipmentNumber,
    onClose,
    reportIssue,
    isBL,
    isBK,
    isHBL,
    classes,
    visible,
    blNumber,
    hblNumber,
    bookingNumber,
    containerNumber,
    currentEventIndex,
    handleOpenProduct,
    lastSuccessfulTrackingStatusUpdatedAt,
  } = props;

  const renderReferenceNumber = () => {
    if (isBL) {
      return <span> BL #{blNumber}</span>;
    }
    if (isBK) {
      return <span> BK #{bookingNumber}</span>;
    }
    if (isHBL) {
      return <span> HBL #{hblNumber}</span>;
    }
    return <span>Container #{containerNumber}</span>;
  };

  const renderMoreDetails = () => {
    if (!lastSuccessfulTrackingStatusUpdatedAt) return null;
    return [
      !isBL && blNumber ?
      <div key="statusUpdatedAt" className={classes.updatedAt}></div> : null,
      <div key="timeAgo"
        style={{ display: 'flex', marginLeft: 8 }}>
        <div>Last Updated:</div>
        <ReactTimeAgo
          style={{ marginLeft: 4 }}
          date={moment(lastSuccessfulTrackingStatusUpdatedAt).valueOf()}
        />
      </div>,
    ];
  };

  const renderDetails = () => {
    return <div
      className={classes.blNumber}>
      {!isBL && blNumber && `BL#: ${blNumber}`}
      {renderMoreDetails()}
    </div>;
  };

  const renderShipmentNumber = () => {
    return <React.Fragment>
      {renderReferenceNumber()}
      {renderDetails()}
    </React.Fragment>;
  };

  const renderTitle = () => {
    if (!showProduct) return renderShipmentNumber();
    return <div className={classes.flexRow}>
      <div style={{ marginRight: 16 }}>
      <span style={{ fontWeight: 'bold' }}>
        Tracking
      </span> {shipmentNumber}
      </div>
      <a
        onClick={handleOpenProduct}
        className={classes.anchor}
        style={{
          fontSize: 14,
        }}
      >
        Show Product Details
      </a>
    </div>;
  };

  return <Drawer
    width="50%"
    closable
    title={renderTitle()}
    placement="right"
    onClose={onClose}
    visible={visible}
    className={classes.drawer}
  >
    <div className={classes.parentContainer}>
      <div style={{ padding: '0px 20px 40px 0' }}>
        <UnifiedTrackingTimeline
          currentEventIndex={currentEventIndex}
          tracking={tracking}/>
      </div>
      {reportIssue ? <div className={classes.anchors}>
        <a className={classes.reportAnchor}
          onClick={reportIssue}>
          Report an Issue
        </a>
      </div> : null}
    </div>
  </Drawer>;
};

const SideDrawerStyed = injectSheet(styles)(SideDrawerTracking);
export default withRouter(SideDrawerStyed);
